export default __webpack_public_path__ + "static/media/news1.b1ad4860.jpg";